import { Injectable } from "@angular/core";
import { Assertion, Component, db, SyncableStatus } from "../../../core/database/db";
import { ComponentConfigurationDTO } from "../../areas/models/configuration/ComponentConfigurationDTO";
import { v4 as uuidv4 } from "uuid";
import { AssertionService } from "../../assertions/services/assertion.service";
import { LoggerService } from "../../../shared/services/logger.service";

@Injectable({ providedIn: "root" })
export class ComponentService {

  constructor(private assertionService: AssertionService, private logger: LoggerService) { }

  public async getComponentsForJob(jobId: number) {
    const lotId = (await db.inspectionJob
      .where("id")
      .equals(jobId)
      .first())?.lotId ?? 0;

    return db.component
      .where("lotId")
      .equals(lotId)
      .toArray();
  }

  public async addComponents(newComponents: Omit<Component, "id" | "updatedAt" | "syncStatus">[]): Promise<Component[]> {
    const updatedAt = new Date();

    const componentsForDb = newComponents.map<Component>(c => ({
      ...c,
      updatedAt,
      syncStatus: SyncableStatus.Pending,
    }));

    const componentIds = await db.batchBulkOperation("addComponents", componentsForDb, batchRecords => db.component.bulkAdd(batchRecords, { allKeys: true }), this.logger);

    return componentsForDb.map((c, index) => ({
      id: componentIds[index],
      ...c,
    }));
  }

  public async addComponentToAreaForJob(newComponentDetail: ComponentConfigurationDTO, areaId: number, jobId: number): Promise<{ addedComponent: Component, addedAssertions: Assertion[] }> {

    const lotId = (await db.inspectionJob
      .where("id")
      .equals(jobId)
      .first())?.lotId ?? 0;

    const { addedComponent, addedAssertions } = await db.transaction("rw", [
      db.component,
      db.assertion,
      db.media,
      db.syncStatus
    ], async () => {
      const newComponent = {
        name: newComponentDetail.name,
        areaId,
        lotId,
        identifier: uuidv4()
      };

      const [addedComponent] = await this.addComponents([newComponent]);

      const newAssertions = newComponentDetail.assertions.map(a => ({
        text: a.text,
        componentId: addedComponent.id!,
        lotId,
        isComplete: false,
        isCcmComplete: false,
        isApplicable: true,
        identifier: uuidv4()
      }));

      const addedAssertions = await this.assertionService.addAssertions(newAssertions);

      return { addedComponent, addedAssertions };
    });

    return { addedComponent, addedAssertions };
  }
}
